import React from 'react'
import { useConfig } from "@revenuewell/logic-config"
import { useOidc } from '@revenuewell/logic-oidc'
import { useNotification } from '@revenuewell/logic-notification'
import { SmsContext } from './context'
import SmsService from '../../services/sms/sms-service'

export function SmsProvider(props: React.PropsWithChildren<unknown>) {
  const { config } = useConfig()
  const { oidcService } = useOidc()
  const { showError } = useNotification()
  const smsService = new SmsService(config, oidcService)

  const sendSms = async (fromLocationId: number, toPhone: string, text: string): Promise<void> => {
    if (!config.textSender.apiUrl || !config.textSender.apiUrl)
      showError("config.json - textSender.apiUrl entry is missing")

    smsService.sendSms(fromLocationId, toPhone, text)
  }

  return <SmsContext.Provider value={{ sendSms }}>
    {props.children}
  </SmsContext.Provider>
}